import Vue from "vue";

import TxSent from "./TxSent";
import EthTxSigningDialog from "./EthTxSigningDialog";
import TendermintTxSigningDialog from "./TendermintTxSigningDialog";
import Gnosis from "./gnosis";
import SolanaTxSigningDialog from "./SolanaTxSigningDialog";
import SuiTxSigningDialog from "./SuiTxSigningDialog";

Vue.component("tx-sent", TxSent);
Vue.component("tx-tendermint", TendermintTxSigningDialog);
Vue.component("tx-ethereum", EthTxSigningDialog);
Vue.component("tx-gnosis", Gnosis);
Vue.component("tx-solana", SolanaTxSigningDialog);
Vue.component("tx-sui", SuiTxSigningDialog);
